import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { motion } from 'framer-motion';
import SearchIcon from '@mui/icons-material/Search';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import BrushIcon from '@mui/icons-material/Brush';
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';
import BugReportIcon from '@mui/icons-material/BugReport';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import BuildIcon from '@mui/icons-material/Build';
import './DevelopmentProcess.css';

const processes = [
  {
    icon: <SearchIcon sx={{ fontSize: 40 }} />,
    title: 'Discovery',
    description: 'Understanding your business needs, objectives, and project requirements through in-depth consultation.'
  },
  {
    icon: <AccountTreeIcon sx={{ fontSize: 40 }} />,
    title: 'Planning',
    description: 'Creating detailed project roadmap, architecture design, and technical specifications.'
  },
  {
    icon: <BrushIcon sx={{ fontSize: 40 }} />,
    title: 'Design',
    description: 'Crafting intuitive user interfaces and experiences that align with your brand identity.'
  },
  {
    icon: <DeveloperModeIcon sx={{ fontSize: 40 }} />,
    title: 'Development',
    description: 'Writing clean, efficient code following best practices and industry standards.'
  },
  {
    icon: <BugReportIcon sx={{ fontSize: 40 }} />,
    title: 'Testing',
    description: 'Rigorous quality assurance to ensure reliability, security, and optimal performance.'
  },
  {
    icon: <RocketLaunchIcon sx={{ fontSize: 40 }} />,
    title: 'Deployment',
    description: 'Smooth deployment process with minimal downtime and maximum security.'
  },
  {
    icon: <BuildIcon sx={{ fontSize: 40 }} />,
    title: 'Maintenance',
    description: 'Ongoing support, updates, and improvements to keep your software running perfectly.'
  }
];

const DevelopmentProcess = () => {
  return (
    <section className="development-process">
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="process-header"
        >
          <Typography variant="h2" className="section-title" gutterBottom>
            Our Development Process
          </Typography>
          <Typography variant="subtitle1" className="sd-dp-section-subtitle" gutterBottom>
            A systematic approach to delivering exceptional software solutions
          </Typography>
        </motion.div>

        <Box className="timeline-container">
          {processes.map((process, index) => (
            <motion.div
              key={index}
              className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}
              initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <div className="timeline-content">
                <div className="sd-process-icon">
                  {process.icon}
                </div>
                <Typography variant="h6" className="process-title">
                  {process.title}
                </Typography>
                <Typography variant="body2" className="process-description">
                  {process.description}
                </Typography>
                <div className="timeline-dot"></div>
                <div className="timeline-connector"></div>
              </div>
            </motion.div>
          ))}
        </Box>
      </Container>
    </section>
  );
};

export default DevelopmentProcess; 